var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ControlBar", {
        attrs: { projectName: _vm.projectName, onFilters: true }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "pageRoot" }, [
        _vm.error
          ? _c("div", { staticClass: "error" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t"),
              _c("div", { staticClass: "tryAgain" }, [
                _c("input", {
                  attrs: { type: "button", value: "Try Again" },
                  on: { click: _vm.loadFilterSummaries }
                })
              ])
            ])
          : _vm.loading || _vm.filterSummaries
          ? _c("div", [
              _c("div", { staticClass: "heading" }, [_vm._v("Filter List")]),
              _vm._v(" "),
              _vm.searchQuery
                ? _c("div", { staticClass: "filterSearchDetailsContainer" }, [
                    _c("b", [
                      _vm._v("Filtered by "),
                      _vm.regexSearch
                        ? _c(
                            "span",
                            { attrs: { title: "Regular Expression" } },
                            [_vm._v("regex")]
                          )
                        : _c(
                            "span",
                            { attrs: { title: "SQL Full Text Search" } },
                            [_vm._v("SQL FTS")]
                          ),
                      _vm._v(":")
                    ]),
                    _vm._v(" " + _vm._s(_vm.searchQuery) + " "),
                    _c("input", {
                      attrs: { type: "button", value: "Clear" },
                      on: { click: _vm.clearSearchQuery }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterSummaries && _vm.filterSummaries.length
                ? _c(
                    "div",
                    { staticClass: "filterSummaryList" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: { move: _vm.moveDragging },
                          on: {
                            start: _vm.startDragging,
                            end: _vm.endDragging
                          },
                          model: {
                            value: _vm.filterSummaries,
                            callback: function($$v) {
                              _vm.filterSummaries = $$v
                            },
                            expression: "filterSummaries"
                          }
                        },
                        _vm._l(_vm.filterSummaries, function(f) {
                          return _c(
                            "router-link",
                            {
                              key: f.filter.FilterId,
                              staticClass: "filterNode",
                              attrs: { to: _vm.makeFilterDetailsLink(f.filter) }
                            },
                            [
                              _c("span", {
                                staticClass: "filterName",
                                domProps: { textContent: _vm._s(f.filter.Name) }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "filterMeta" }, [
                                _vm._v(
                                  "[" +
                                    _vm._s(f.NumConditions) +
                                    " Conditions, " +
                                    _vm._s(f.NumActions) +
                                    " Actions]"
                                )
                              ]),
                              _vm._v(" "),
                              f.filter.Enabled
                                ? _c(
                                    "span",
                                    { staticClass: "filterMeta filterEnabled" },
                                    [_vm._v("[Enabled]")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !f.filter.Enabled
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filterMeta filterDisabled"
                                    },
                                    [_vm._v("[Disabled]")]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterSummaries && _vm.filterSummaries.length === 0
                ? _c("div", [
                    _vm._v("This project does not have any filters yet.")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "buttonBar" }, [
                _c("input", {
                  attrs: { type: "button", value: "New Filter" },
                  on: { click: _vm.newFilter }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "button",
                    value: "Run enabled filters against all events"
                  },
                  on: { click: _vm.runFilters }
                })
              ]),
              _vm._v(" "),
              _vm.loading
                ? _c("div", { staticClass: "loadingOverlay" }, [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("ScaleLoader"), _vm._v(" Loading…")],
                      1
                    )
                  ])
                : _vm._e()
            ])
          : _c("div", [
              _vm._v(
                "\n\t\t\tFailed to load filter list for project: " +
                  _vm._s(_vm.projectName) +
                  "\n\t\t\t"
              ),
              _c("div", { staticClass: "tryAgain" }, [
                _c("input", {
                  attrs: { type: "button", value: "Try Again" },
                  on: { click: _vm.loadFilterSummaries }
                })
              ])
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }